export default __webpack_public_path__ + "c548ea8d6da018d8d3e3f196b2174234.svg";